import { Controller } from '@hotwired/stimulus';
import { useDebounce, useIntersection } from 'stimulus-use';

export default class extends Controller {
  static debounces = [{ name: 'debouncedSearch', wait: 300 }];

  connect() {
    useDebounce(this);
    useIntersection(this);
  }

  debouncedSearch() {
    this.element.requestSubmit();
  }

  appear(_entry, _observer) {
    // Start a "blank" search when the form in the tab becomes visible so that
    // some results are shown by default
    this.debouncedSearch();
  }
}
